export default "__VITE_ASSET__CM0L1pni__"